module.exports = __webpack_public_path__ + "img/month.56034851.png";